import { put, select, takeLeading } from 'redux-saga/effects';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import { callApi, callApiNext } from 'helpers/saga-helpers';
import {
  REQUEST_CREATE_EXPERTISE_VICTIM,
  REQUEST_GET_EXPERTISE_VICTIM,
  REQUEST_CREATE_MISSION_POSTPONE,
  REQUEST_GET_MISSION_POSTPONE,
  REQUEST_GET_MISSION_POSTPONE_EXPERTISE,
  REQUEST_UPDATE_MISSION_EXPERTISE,
  REQUEST_UPDATE_MISSION_POSTPONE,
  REQUEST_REJECT_MISSION,
} from 'containers/ExpertExpertise/constants';
import {
  requestGetMissionPostPone,
  setExpertiseVictim,
  setMissionPostPone,
  setMissionPostPoneExpertise,
  requestGetMissionPostPoneExpertise,
  requestGetExpertiseVictim,
} from 'containers/ExpertExpertise/actions';
import { MISSION_POSTPONE_TYPE } from 'containers/data-structure';
import accessTokenStorage from 'containers/services/security/access-token-storage';
import { renderPathApiByPayload } from 'containers/ExpertExpertise/utils';

export function* makeRequestCreateExpertiseVictim(
  action: any,
): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (!token) return;
  const path = payload.damageAmount
    ? `/corporeal/mission-expertise-vehicle`
    : `/corporeal/mission-expertise-victim`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
    yield put(
      requestGetExpertiseVictim({
        missionId: payload.missionId,
        missionVictimId: payload.missionVictimId,
        missionVehicleId: payload.MissionVehicleId,
        isIntervenant: true,
      }),
    );
  }
}

export function* makeRequestCreateExpertiseVictimSaga() {
  yield takeLeading(
    REQUEST_CREATE_EXPERTISE_VICTIM,
    makeRequestCreateExpertiseVictim,
  );
}
export function* makeRequestGetExpertiseVictim(
  action: any,
): Generator<unknown> {
  const { payload } = action;
  const token = payload.isIntervenant
    ? yield select(makeSelectKeycloakToken())
    : accessTokenStorage.get().token;
  if (!token) return;
  const path = payload.isIntervenant
    ? renderPathApiByPayload(payload) + '&isIntervenant=true'
    : renderPathApiByPayload(payload);
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };
  yield callApiNext(path, {}, options, [], setExpertiseVictim);
  if (!payload.isLegalProceeding) {
    yield put(
      requestGetMissionPostPone({
        claimId: payload.claimId,
        missionId: payload.missionId ? payload.missionId : null,
        type: MISSION_POSTPONE_TYPE.NOTICE_DEFICIENCY,
        isIntervenant: payload.isIntervenant,
      }),
    );
    yield put(
      requestGetMissionPostPoneExpertise({
        claimId: payload.claimId,
        missionId: payload.missionId ? payload.missionId : null,
        type: MISSION_POSTPONE_TYPE.POSTPONEMENTS_EXPERTISE,
        isIntervenant: payload.isIntervenant,
      }),
    );
  }
}

export function* makeRequestGetExpertiseVictimSaga() {
  yield takeLeading(
    REQUEST_GET_EXPERTISE_VICTIM,
    makeRequestGetExpertiseVictim,
  );
}

export function* makeRequestCreateMissionPostPone(
  action: any,
): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (!token) return;
  const path = `/corporeal/mission-postpone/add`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
    if (
      payload.missionPostPone.type === MISSION_POSTPONE_TYPE.NOTICE_DEFICIENCY
    ) {
      yield put(
        requestGetMissionPostPone({
          missionId: payload.missionId,
          type: payload.missionPostPone.type,
          claimId: null,
          isIntervenant: true,
        }),
      );
    } else {
      yield put(
        requestGetMissionPostPoneExpertise({
          missionId: payload.missionId,
          type: payload.missionPostPone.type,
          claimId: null,
          isIntervenant: true,
        }),
      );
    }
  }
}
export function* makeRequestCreateMissionPostPoneSaga() {
  yield takeLeading(
    REQUEST_CREATE_MISSION_POSTPONE,
    makeRequestCreateMissionPostPone,
  );
}
export function* makeRequestGetMissionPostPone(
  action: any,
): Generator<unknown> {
  const { payload } = action;
  const token = payload.isIntervenant
    ? yield select(makeSelectKeycloakToken())
    : accessTokenStorage.get().token;
  if (!token) return;
  const path =
    payload.isIntervenant && !payload.claimId
      ? `/corporeal/mission-postpone?missionId=${payload.missionId}&type=${payload.type}`
      : `/corporeal/mission-postpone?claimId=${payload.claimId}&type=${payload.type}`;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, {}, options, [], setMissionPostPone);
}
export function* makeRequestGetMissionPostPoneSaga() {
  yield takeLeading(
    REQUEST_GET_MISSION_POSTPONE,
    makeRequestGetMissionPostPone,
  );
}
export function* makeRequestGetMissionPostPoneExpertise(
  action: any,
): Generator<unknown> {
  const { payload } = action;
  const token = payload.isIntervenant
    ? yield select(makeSelectKeycloakToken())
    : accessTokenStorage.get().token;
  if (!token) return;
  const path =
    payload.isIntervenant && !payload.claimId
      ? `/corporeal/mission-postpone?missionId=${payload.missionId}&type=${payload.type}`
      : `/corporeal/mission-postpone?claimId=${payload.claimId}&type=${payload.type}`;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, {}, options, [], setMissionPostPoneExpertise);
}

export function* makeRequestGetMissionPostPoneExpertiseSaga() {
  yield takeLeading(
    REQUEST_GET_MISSION_POSTPONE_EXPERTISE,
    makeRequestGetMissionPostPoneExpertise,
  );
}
export function* makeRequestUpdateMissionExpertiseSaga(
  action: any,
): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (!token) return;
  const path = payload.damageAmount
    ? `/corporeal/mission-expertise-vehicle/change`
    : `/corporeal/mission-expertise-victim/change`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
    yield put(
      requestGetExpertiseVictim({
        missionId: payload.missionId,
        missionVictimId: payload.missionVictimId,
        isIntervenant: true,
        missionVehicleId: payload.MissionVehicleId,
      }),
    );
  }
}
export function* requestUpdateMissionExpertiseSaga() {
  yield takeLeading(
    REQUEST_UPDATE_MISSION_EXPERTISE,
    makeRequestUpdateMissionExpertiseSaga,
  );
}
export function* makeRequestUpdateMissionPostPoneSaga(
  action: any,
): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (!token) return;
  const path = `/corporeal/mission-postpone/change`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
    if (payload.type === MISSION_POSTPONE_TYPE.NOTICE_DEFICIENCY) {
      yield put(
        requestGetMissionPostPone({
          missionId: payload.missionId,
          type: payload.type,
          claimId: null,
          isIntervenant: true,
        }),
      );
    } else {
      yield put(
        requestGetMissionPostPoneExpertise({
          missionId: payload.missionId,
          type: payload.type,
          claimId: null,
          isIntervenant: true,
        }),
      );
    }
  }
}
export function* requestUpdateMissionPostPoneSaga() {
  yield takeLeading(
    REQUEST_UPDATE_MISSION_POSTPONE,
    makeRequestUpdateMissionPostPoneSaga,
  );
}
export function* makeRequestRejectMissionSaga(action: any): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (!token) return;
  const path = `/corporeal/mission/reject-mission`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
  }
}
export function* requestRejectMissionSaga() {
  yield takeLeading(REQUEST_REJECT_MISSION, makeRequestRejectMissionSaga);
}
export default [
  makeRequestCreateExpertiseVictimSaga,
  makeRequestGetExpertiseVictimSaga,
  makeRequestCreateMissionPostPoneSaga,
  makeRequestGetMissionPostPoneSaga,
  makeRequestGetMissionPostPoneExpertiseSaga,
  requestUpdateMissionExpertiseSaga,
  requestUpdateMissionPostPoneSaga,
  requestRejectMissionSaga,
];
